define(['app/modules/map_loader'], function (loadMap) {
  var mapLoader = loadMap();

  var init = function (element, options) {
    return mapLoader.then(() => {
      options = options || {};

      var mapOptions = {
        center: new google.maps.LatLng((options.lat || 51.507351), (options.lon || -0.127758)),
        zoom: options.zoom || 12
      };
      var map = new google.maps.Map(element, mapOptions);

      return map;
    });
  };

  var addMarker = function(map, options){
    var coords = new google.maps.LatLng(options.lat, options.lon);

    var marker = new google.maps.Marker({
      position: coords,
      map: map
    });

    if (options.infoWindow) {
      var infowindow = new google.maps.InfoWindow({
        content: options.infoWindow.title
      });

      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });
    }

    return marker;
  };

  var clearMarkers = function(markers){
    mapLoader.then(() => {
      markers = markers || {};
      $.each(markers, function(key, val){
        val.setMap(null);
      });
    })
  };

  var showMarker = function (map, marker) {
    if(map){
      marker.setMap(map);
      map.setCenter(new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng()));
    }
  };

  var geoLocate = function(geocoder, address, map) {
    return new Promise(function(resolve, reject) {
      geocoder.geocode({'address': address}, function(results, status) {
        if (status === 'OK') {
          map.setCenter(results[0].geometry.location);
          var marker = new google.maps.Marker({
            map: map,
            position: results[0].geometry.location
          });
          resolve(marker);
        }
      });
    });
  };

  return {
    init: init,
    addMarker: addMarker,
    clearMarkers: clearMarkers,
    showMarker: showMarker,
    geoLocate: geoLocate
  };
});
